import React from 'react';
import {BaseComponent as Component} from 'BaseComponent';
import DisabledPlayerIfGameLockedSpecification from 'specifications/disabled-player-if-game-locked-specification';
import PopupOpener from 'components/atoms/popup-opener';
import AvailablePlayers from 'components/organisms/players-to-exchange';
import {getOpponentsDelimiterByPlayer} from 'helpers/player-helper';
import PlayerPointsView from 'components/organisms/lineup/components/player-points-view';
import DisabledPlayerIfGameInactiveSpecification from 'specifications/disabled-player-if-game-inactive-specification';

class LineupPlayers extends Component {
    getRowClassName(player) {
        const {filterLineupsByPlayer} = this.props;
        const isFilterEnabled = filterLineupsByPlayer.isPlayerChecked(player.getId());
        const isGameLocked = this.isPlayerGameLocked(player);
        const isGameInactive = this.isPlayerGameInactive(player);
        const isPlayerDisabled = isGameLocked || isGameInactive;

        // const map = {
        //     PG: ['PG'],
        //     SG: ['SG'],
        //     PF: ['PF'],
        //     SF: ['SF'],
        //     C: ['C'],
        //     G: ['SG', 'PG'],
        //     F: ['SF', 'PF'],
        //     UTIL: ['SF', 'PF', 'SG', 'PG', 'C'],
        // };
        //
        // const isPlayerOnWrongPosition = !arrayDuplicates(player.positionShortNames, map[player.positionInLineup]).length;

        const classNames = [];

        isFilterEnabled && classNames.push('checked-player');
        isPlayerDisabled && classNames.push('disabled-player');
        // isPlayerOnWrongPosition && classNames.push('disabled-player');
        isGameInactive && classNames.push('inactive-game');

        return classNames.join(' ');
    }
    isPlayerGameLocked(player) {
        const {sportConfig, games = {}} = this.props;

        return DisabledPlayerIfGameLockedSpecification.isSatisfiedBy({sportConfig, games, player});
    }
    isPlayerGameInactive(player) {
        const {sportConfig, games = {}} = this.props;

        return DisabledPlayerIfGameInactiveSpecification.isSatisfiedBy({sportConfig, games, player});
    }
    getExchangePlayerButton(params) {
        const {player, lineup} = params;
        const {sportConfig} = this.props;

        if (this.isPlayerGameLocked(player)) {
            return null;
        }

        return (
            <PopupOpener
                tooltipText="Change player"
                component={<AvailablePlayers lineup={lineup} playerToBeSwapped={player} sportConfig={sportConfig} />}
            >
                <i className="fa fa-exchange" />
            </PopupOpener>
        );
    }
    getOpponentsDelimiter(player) {
        return getOpponentsDelimiterByPlayer(player);
    }
    getPlayerPointsView(player) {
        return <PlayerPointsView player={player} />;
    }
    getStackClassName(player) {
        if (!('stackPlayerAnalyzer' in this)) {
            return '';
        }

        if (this.stackPlayerAnalyzer.isPlayerFromPrimaryStack(player)) {
            return 'primary-stack-color';
        } else if (this.stackPlayerAnalyzer.isPlayerFromSecondaryStack(player)) {
            return 'secondary-stack-color';
        } else if (this.stackPlayerAnalyzer.isPlayerFromThirdStack(player)) {
            return 'third-stack-color';
        } else if (this.stackPlayerAnalyzer.isPlayerFromFourthStack(player)) {
            return 'fourth-stack-color';
        } else if (this.stackPlayerAnalyzer.isPlayerFromFifthStack(player)) {
            return 'fifth-stack-color';
        }

        return '';
    }
}

export {LineupPlayers};
